import { actions, reducer } from './reducer';
import { saga } from './sagas';
import * as selectors from './selectors';

export const snackbarModel = { actions, reducer, selectors, saga };
